<template>
  <CContainer fluid class="mt-3 bg-whitesmoke">
    <CCard class="bg-white">
      <CCardBody>
        <CRow class="mt-3">
          <CCol>
            <CSelect
              :options="licenseOptions"
              :value.sync="licenseInput"
              label="License"
              placeholder="Silahkan Pilih License"
            />
          </CCol>
          <CCol>
            <CSelect
            :options="statusOptions"
            :value.sync="statusInput"
            label="Status"
            placeholder="Silahkan Pilih Status"
            />
          </CCol>        
        </CRow>
        <CRow>
          <CCol>
            <label>Start Date</label>
            <datepicker :disabled-dates="disabledStartDate" format="dd-MM-yyyy" v-model="startDate"></datepicker>
          </CCol>
          <CCol>        
            <label>End Date</label>
            <datepicker :disabled-dates="disabledEndDate" format="dd-MM-yyyy" v-model="endDate"></datepicker>
          </CCol>
        </CRow>
        <div class="my-3 d-flex flex-row-reverse">
          <div class="d-flex">
            <CButton class="mr-2" size="sm" color="success" :disabled="disableFetchDataButton" @click="fetchData()">Filter</CButton>
            <CButton size="sm" color="primary" :disabled="disableFetchDataButton" @click="fetchCSV()">CSV</CButton>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol class="mt-3 mb-2">
        <div class="pl-3 py-2 callout-container">
          <CCallout color="info">
            <small class="h5 text-muted">Total Request</small><br>
            <strong class="h3">{{totalRequest}}</strong>
          </CCallout>
        </div>
      </CCol>
      <CCol class="mt-3 mb-2">
        <div class="pl-3 py-2 callout-container">
          <CCallout color="success">
            <small class="h5 text-muted">Total Success</small><br>
            <strong class="h3">{{totalSuccess}}</strong>
          </CCallout>
        </div>
      </CCol>
      <CCol class="mt-3 mb-2">
        <div class="pl-3 py-2 callout-container">
          <CCallout color="danger">
            <small class="h5 text-muted">Total Failures</small><br>
            <strong class="h3">{{totalFailures}}</strong>
          </CCallout>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol class="p-2 my-2">        
        <div class="p-2 col-chart-container">
          <div class="mb-1 p-3 border-grey">
            License Expiry Date : {{licenseExpiry}}           
          </div>     
          <chart :options="highchartsOptions"></chart>
        </div>
      </CCol>
    </CRow>
    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
    <CModal
     color="primary"
     :show.sync="showModalCsv" :centered="true"
     :closeOnBackdrop="false"
    >
      <div slot="header">
        <h5>Reporting</h5>
      </div>
      <div class="">
        CSV File anda berhasil di buat.
      </div>
      <div slot="footer">
        <vue-json-to-csv v-if="jsonToCsvData.length != 0" class="json-to-csv-button btn-primary" :json-data="jsonToCsvData" :csv-title="csvTitle">Unduh</vue-json-to-csv>
        <CButton class="ml-2" color="danger" @click="showModalCsv = false">Cancel</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueJsonToCsv from 'vue-json-to-csv';
import { Chart } from 'highcharts-vue';

export default {
  name: 'TestChart',
  components: {
    Chart,
    VueJsonToCsv,
    Datepicker
  },
  data(){
    return {
      showErrorModal: false,
      showModalCsv: false,
      csvTitle: 'csvdata',
      jsonToCsvData: [],
      errorLabel: 'Error occured.',
      modalTitle: 'Error System!',
      endDate: new Date(),
      startDate: new Date(),
      disabledStartDate: {
        from: new Date()
      },
      licenseOptions: [],
      licenseInput: '',
      statusOptions: [
        { value: 'all', label: 'All'},
        { value: 'success', label: 'Success'},
        { value: 'error', label: 'Error'},
      ],
      statusInput: 'all',
      totalRequest: 0,
      totalSuccess: 0,
      totalFailures: 0,
      licenseExpiry: '',
      highchartsOptions: {
        chart: {
          zoomType: 'x', // to make chart zoomable based on x axis choosen
          height: (9 / 16 * 100) + '%', // to make 16:9 resolution
          animation: true,
          plotBorderWidth: 1,
          spacingRight: 50,
          selectionMarkerFill: 'rgba(52, 124, 224, 0.5)' // color for area choosen (when click and drag for zoom)
        },
        credits: {
          enabled: false
        },
        caption: {
          text: 'Click and drag in the chart to zoom in.',
          align: 'right'
        },
        title: {
          text: '.',
          style: {
            color: '#fff',
            fontSize: '20px'
          }
        },
        plotOptions: {
          series: {
            color: '#FF0000'
          }
        },
        yAxis: {
          title: {
            text: 'Total Requests',
            style: {
              color: '#3c4b64',
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          labels: {
            style: {
              color: '#3c4b64', // ngikut warna dari font root
              fontSize: '12px'
            }
          },
          crosshair: true,
          lineColor: '#2157b5',
          lineWidth: 2,
          gridLineColor: '#1508488e'
        },
        xAxis: {
          title: {
            text: 'Tanggal',
            style: {
              color: '#3c4b64',
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          labels: {
            style: {
              color: '#3c4b64', // ngikut warna dari font root
              fontSize: '11px'
            }
          },
          crosshair: true,
          type: 'datetime',
          categories: [], // for x axis data
          lineColor: '#2157b5',
          lineWidth: 2
        },
        legend: {
          enabled: false
        },
        series: [{
          type: 'line',
          name: 'API Hit',
          data: [] // for y axis data
        }]
      }
    }
  },
  methods: {
    // integrating with API
    maptableSeries(arraySeries){
      let result = { x: [], y: []};
      let resultX = [];
      let resultY = [];
      for (const iterator of arraySeries) {
        resultX.push(iterator.date);
        resultY.push(iterator.hits);
      }
      result.x = resultX; // for x axis data
      result.y = resultY; // for y axis data
      return result;
    },
    fetchData(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/dashboard';
      let startDateFormatted = this.startDate.toISOString().split('T')[0];
      let endDateFormatted = this.endDate.toISOString().split('T')[0];
      console.log(this.$axios);
      this.$axios.post(processUrl, {license_id: this.licenseInput, start_date: startDateFormatted, end_date: endDateFormatted, status: this.statusInput})
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            let resultSeries = this.maptableSeries(response.data.data.chart);
            this.highchartsOptions.series[0].data = resultSeries.y; // for y axis data
            this.highchartsOptions.xAxis.categories = resultSeries.x; // for x axis data
            this.totalRequest = response.data.data.total_requests;
            this.totalSuccess = response.data.data.total_success;
            this.totalFailures = response.data.data.total_failures;
            this.licenseExpiry = this.parsingStringDate(response.data.data.license_expiry);
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    fetchCSV(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/dashboard/csv';
      let startDateFormatted = this.startDate.toISOString().split('T')[0];
      let endDateFormatted = this.endDate.toISOString().split('T')[0];
      this.$axios.post(processUrl, {license_id: this.licenseInput, start_date: startDateFormatted, end_date: endDateFormatted, status: this.statusInput})
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            if(response.data.data.length > 0){
              this.jsonToCsvData = response.data.data;
              this.csvTitle = startDateFormatted+ '_'+endDateFormatted+' data';
              this.showModalCsv = true;
            } else {
              this.modalTitle = 'Data kosong';
              this.errorLabel = 'Data API Hit untuk rentang tanggal yang dipilih kosong';
              this.showErrorModal = true;
            }            
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    getLicenseOptions(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/licenses';
      return this.$axios.get(processUrl)
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            let options = response.data.data;
            for (const iterator of options) {
              let option = { value: iterator.id, label: iterator.name};
              this.licenseOptions.push(option);
            }
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    parsingStringDate(string){
      var year = string.substring(0,4);
      var month = string.substring(5,7);
      var date = string.substring(8,10);
      return date+ '-' + month + '-' + year;
    },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    }
  },
  computed: {
    disableFetchDataButton(){
      if(this.licenseInput == '' || this.statusInput == '' || this.startDate == '' || this.endDate == ''){
        return true;
      } else { return false }
    },
    disabledEndDate(){
      return {
        to: new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate()),
        from: new Date()
      }
    }
  },
  watch: {
    startDate(val){
      if(val.getTime() > this.endDate.getTime()){
        this.endDate = val;
      }
    }
  },
  async created(){
    await this.getLicenseOptions();
    this.licenseInput = this.licenseOptions[0].value;
    let minus7 = new Date();
    minus7.setDate(minus7.getDate() - 7);
    this.startDate = minus7;
    await this.fetchData();
  }
}
</script>

<style>
</style>